import { useCallback, useMemo, useState } from "react";
import { PreDefinedFileTypeFilter } from "../helper";
import { FileTypeFilter } from "../types";

const useHandleFMListing = () => {
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [selectedCategory, setSelectedCategory] = useState<string>('');
  const [selectedSubCategory, setSelectedSubCategory] = useState<string>('');
  const initialFileTypeFiltersCollection: FileTypeFilter[] = useMemo(() => {
    return PreDefinedFileTypeFilter.map((item: FileTypeFilter) => {
      return {
        ...item,
      }
    })
  }, [])
  const [fileTypeFiltersCollection, setFileTypeFiltersCollection] = useState<FileTypeFilter[]>(initialFileTypeFiltersCollection);

  const handleUploadClick = useCallback(async () => {
    setShowDialog(true);
  }, [])

  const onDialogClose = useCallback(() => {
    setShowDialog(false);
  }, [])

  const handleCategorySelect = useCallback((value: string) => {
    setSelectedCategory(value);
  }, [])

  const handleSubCategorySelect = useCallback((value: string) => {
    setSelectedSubCategory(value);
  }, [])

  const handleFileTypeFiltersCollection = useCallback((index: number) => {
    setFileTypeFiltersCollection((prev: FileTypeFilter[]) => {
      let newCollection = [...prev];
      newCollection[index].selected = !newCollection[index].selected;
      return newCollection;
    });
  }, [fileTypeFiltersCollection])

  const handleClearAll = () => {
    let newCollection = [...fileTypeFiltersCollection];
    newCollection.forEach((item: FileTypeFilter) => {
      item.selected = false;
    })
    setFileTypeFiltersCollection(newCollection);
  }

  const selectedFileTypes: string[] = useMemo(() => {
    return fileTypeFiltersCollection.filter((item: FileTypeFilter) => item.selected).map((item: FileTypeFilter) => item.label);
  }, [fileTypeFiltersCollection])

  const activeFiltersCount = useMemo(() => {
    let count = 0;
    if(selectedCategory) count++;
    if(selectedSubCategory) count++;
    return count;

  }, [selectedCategory, selectedSubCategory])


  return {
    showDialog,
    selectedCategory,
    selectedSubCategory,
    handleUploadClick,
    onDialogClose,
    handleCategorySelect,
    handleSubCategorySelect,
    fileTypeFiltersCollection,
    handleFileTypeFiltersCollection,
    handleClearAll,
    selectedFileTypes,
    activeFiltersCount
  }
}

export default useHandleFMListing;